export default {
  createRole: '/authorize-service/authorize/role/createRole',
  deleteRoleById: '/authorize-service/authorize/role/deleteRoleById',
  editRoleFlag: '/authorize-service/authorize/role/editRoleFlag',
  updateRole: '/authorize-service/authorize/role/updateRole',
  queryCurrentRole: '/authorize-service/authorize/role/queryCurrentRole',
  queryRoleByPage: '/authorize-service/authorize/role/queryRoleByPage',
  queryRoleList: '/authorize-service/authorize/role/queryRoleList',
  saveRoleMenu: '/authorize-service/authorize/role/saveRoleMenu',
  selectMenuByRole: '/authorize-service/authorize/role/selectMenuByRole'
}



// WEBPACK FOOTER //
// ./src/config/authority/role/index.js